var cov_2n44euub1f = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Divider/styles/index.ts",
      hash = "5f1ba828cae9eb5e045bebc550ce515d958cef9b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Divider/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 28
        },
        end: {
          line: 5,
          column: 62
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var dividerLess = {};
import genaration from '../../utils/classname';
export var dividerClass = (cov_2n44euub1f.s[0]++, genaration(dividerLess, 'divider'));